import { isAfter, isSameDay } from 'date-fns';
import React from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import { PromotionSectionCard } from './PromotionSectionCard';
import { Pencil } from '../../assets/Pencil';
import { formatDateTime } from '../../utils';

export function ActiveDatesSection({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  endDateError,
  setEndDateError,
  isOptional = true,
  description = 'The customer will only receive this promotion if they check out with their trial order within this timeframe',
}: {
  startDate?: Date;
  endDate?: Date;
  setStartDate: (d?: Date) => void;
  setEndDate: (d?: Date) => void;
  endDateError: string;
  setEndDateError: (s: string) => void;
  isOptional?: boolean;
  description?: string;
}) {
  return (
    <PromotionSectionCard>
      <h2>Active dates {isOptional && <span className="text-xs">(Optional)</span>}</h2>
      <p className="text-xs text-gray-500 font-normal">{description}</p>

      <div className="flex mt-2">
        <div className="w-1/2 pr-2">
          <h3>Start Date</h3>
          <div className="w-full mb-2">
            <DatePicker
              selected={startDate}
              minDate={new Date()}
              onChange={(date: Date) => {
                setStartDate(date);
                if (date && endDate && date >= endDate)
                  setEndDateError('End time must be later than start time');
                else setEndDateError('');
              }}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={30}
              dateFormat="dd/MM/yyyy"
              customInput={
                <div className="flex items-center cursor-pointer">
                  <span>
                    {startDate ? formatDateTime(startDate.toString(), true) : 'Select Date'}
                  </span>
                  <Pencil className="w-4 h-4 ml-1 mb-1" />
                </div>
              }
            />
          </div>
        </div>

        <div className="w-1/2">
          <h3>End Date</h3>
          <div className="w-full mb-2">
            <DatePicker
              key={startDate?.toString()}
              selected={endDate || startDate}
              minDate={startDate || new Date()}
              filterTime={(time) => {
                if (startDate && isSameDay(time, startDate)) return isAfter(time, startDate);
                return true;
              }}
              onChange={(date: Date) => {
                setEndDate(date);
                if (date && startDate && date <= startDate)
                  setEndDateError('End time must be later than start time');
                else setEndDateError('');
              }}
              dateFormat="dd/MM/yyyy"
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={30}
              customInput={
                <div className="flex items-center cursor-pointer">
                  <span>{endDate ? formatDateTime(endDate.toString(), true) : 'Select Date'}</span>
                  <Pencil className="w-4 h-4 ml-1 mb-1" />
                </div>
              }
            />
            {endDateError && (
              <div className="error text-red-500 text-xs font-normal">{endDateError}</div>
            )}
          </div>
        </div>
      </div>
    </PromotionSectionCard>
  );
}
